<template>
  <path
    d="M2.73004 21.0002H21.26C22.03 21.0002 22.51 20.1702 22.13 19.5002L12.86 3.50018C12.47 2.83018 11.51 2.83018 11.13 3.50018L1.86004 19.5002C1.48004 20.1702 1.96004 21.0002 2.73004 21.0002ZM13 18.0002H11V16.0002H13V18.0002ZM12 14.0002C11.45 14.0002 11 13.5502 11 13.0002V11.0002C11 10.4502 11.45 10.0002 12 10.0002C12.55 10.0002 13 10.4502 13 11.0002V13.0002C13 13.5502 12.55 14.0002 12 14.0002Z"
  />
</template>
